(() => {
  'use strict';
  const page = document.querySelector('[data-wholesale-page]');
  const form = document.getElementById('ozbee-wholesale-form');
  if (!page || !form) return;
  const success = form.querySelector('[data-wholesale-success]');
  const receiptKey = 'ozbee-wholesale-receipt';
  if (success) {
    try {
      const receipt = JSON.parse(sessionStorage.getItem(receiptKey) || 'null');
      sessionStorage.removeItem(receiptKey);
      if (receipt) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'wholesale_enquiry_submitted', ...receipt });
      }
    } catch (_) { /* Submission still succeeds when storage is unavailable. */ }
    success.focus();
    return;
  }
  form.addEventListener('submit', () => {
    try {
      sessionStorage.setItem(receiptKey, JSON.stringify({
        business_type: form.querySelector('[data-wholesale-business-type]')?.value || '',
        buying_for: form.querySelector('[data-wholesale-buying-for]')?.value || '',
        order_frequency: form.querySelector('[data-wholesale-frequency]')?.value || ''
      }));
    } catch (_) { /* Submission still succeeds when storage is unavailable. */ }
  });
})();
